import _ from 'lodash'
import Table from './table'
import Toolbar from './toolbar'
import { useEffectOnce } from 'react-use'
import { useLocation } from 'react-router-dom'
import { requestUserSocialBadgeListPromise } from 'api/SocialBadge'
import React, { useState, useEffect, useCallback, useRef } from 'react'

const RecordList = props => {
  const ref = useRef()
  const location = useLocation()
  const [records, setRecords] = useState({})
  const [params, setParams] = useState({})

  useEffectOnce(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())

    setParams(too)
  })

  // load data
  useEffect(() => {
    const foo = new URLSearchParams(location.search)
    const too = Object.fromEntries(foo.entries())
    requestUserSocialBadgeListPromise(too).then(resp => setRecords(resp))
  }, [location.search])

  const handleParamsChange = useCallback((payload, delay = 0) => {
    if (ref.current) clearTimeout(ref.current)

    const foo = Object.fromEntries(new URLSearchParams(location.search))
    const too = _.pickBy({ ...foo, page: undefined, ...payload }, _.identity)
    setParams(too)

    ref.current = setTimeout(() => props.history.push(`?${new URLSearchParams(too)}`), delay)
  }, [location.search, props.history])

  return (
    <div className={'root'}>
      <div className={'content'}>
        <Toolbar params={params} onParamsChange={handleParamsChange} {...props} />
        <br />
        <Table
          {...props}
          data={records}
          page={params.page || 1}
          onParamsChange={handleParamsChange}
        />
      </div>

    </div>
  )
}

export default RecordList